import { Trash04Icon } from '@langchain/untitled-ui-icons';
import { Button, Modal, ModalDialog } from '@mui/joy';

import { ExpandableErrorAlert } from '@/components/ExpandableErrorAlert';
import { choosePlural } from '@/utils/stringUtils';

import { ANNOTATION_QUEUE_COLLAB_SETTINGS_DOCS_HREF } from './constants';

export const DeleteAnnotationQueueRunsModal = ({
  deleteModalOpen,
  setDeleteModalOpen,
  numRunsSelected,
  numHiddenRuns,
  onDeleteRuns,
  deleteMutating,
  deleteError,
  totalQueueSize,
  queueSize,
}: {
  deleteModalOpen: boolean;
  setDeleteModalOpen: (open: boolean) => void;
  numRunsSelected: number;
  numHiddenRuns: number;
  onDeleteRuns: () => void;
  deleteMutating: boolean;
  deleteError: any;
  totalQueueSize: number;
  queueSize: number;
}) => {
  return (
    <Modal open={deleteModalOpen} onClose={() => setDeleteModalOpen(false)}>
      <ModalDialog>
        <div className="flex flex-col gap-4">
          <div className="flex gap-4">
            <div className="self-start rounded-full bg-error-secondary p-4">
              <Trash04Icon className="h-6 w-6 text-error" />
            </div>
            <div className="flex flex-col gap-2">
              <div className="text-base font-semibold">
                Delete {numRunsSelected}{' '}
                {numRunsSelected === 1 ? 'run' : 'runs'} from the queue?
              </div>
              <div className="max-w-[350px] text-sm font-normal text-quaternary">
                This will delete the{' '}
                {choosePlural(
                  'selected run',
                  `${numRunsSelected} selected runs`,
                  numRunsSelected
                )}{' '}
                from the queue for all workspace members. This action cannot be
                undone.
                {numHiddenRuns > 0 ? (
                  <>
                    <br /> <br />
                    <span>
                      This includes {totalQueueSize - queueSize}{' '}
                      {choosePlural('run', 'runs', totalQueueSize - queueSize)}{' '}
                      that are not visible to you but may be visible for others,
                      either because you have already marked them "done" or
                      because someone else has reserved them.{' '}
                      <a
                        href={ANNOTATION_QUEUE_COLLAB_SETTINGS_DOCS_HREF}
                        className="text-ls-blue underline"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Read more about collaborator settings here.
                      </a>
                    </span>
                  </>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
          <div className="flex gap-2 self-end">
            <Button
              key="cancel"
              variant="outlined"
              onClick={() => setDeleteModalOpen(false)}
            >
              Cancel
            </Button>
            <Button
              key="delete"
              color="danger"
              onClick={onDeleteRuns}
              loading={deleteMutating}
            >
              Delete
            </Button>
          </div>
          {deleteError && <ExpandableErrorAlert error={deleteError} />}
        </div>
      </ModalDialog>
    </Modal>
  );
};
